import { StyleSheet, Dimensions } from 'react-native';

import { Colors } from '../../../Components/Themes';

const { height, width } = Dimensions.get('window');

export const circleHeight = height * 1.5;
export const circleWidth = width * 1.5

export default StyleSheet.create({
  container: {
    position: 'absolute',
    backgroundColor: Colors.vfRed,
    height: '100%',
    width: '100%',
  },
  fadingContainer: {
    backgroundColor: Colors.transparent,
    borderColor: Colors.vfRed,
    borderRadius: '50%',
    borderWidth: circleHeight > circleWidth ? circleHeight / 2.4 : circleWidth / 2.2,
    height: circleHeight > circleWidth ? circleHeight : circleWidth,
    width: circleHeight > circleWidth ? circleHeight : circleWidth
  },
  fadeOuterContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.vfRed,
  },
  logoWrapper: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    height: 236.8,
    width: 236.8,
  },
  logoContainerStyle: {
    alignItems: 'center',
    backgroundColor: Colors.transparent,
    flex: 1,
    justifyContent: 'center',
    zIndex: 24,
    ...StyleSheet.absoluteFillObject,
  },
  modalStyle: {
    margin: 0,
  },
  wrappedComponentContainer: {
    flex: 1,
  },
  screenHiddenContainer: {
    flex: 1,
    backgroundColor: Colors.vfRed,
  },
});
